<template>
  <div class="login">
    <ul class="tabs">
      <li><router-link :to="findPwdByWechatUri">微信找回</router-link></li>
      <li class="active"><router-link :to="findPwdByMobileUri">手机号找回</router-link></li>
    </ul>
    <div class="inputs">
      <input v-if="$route.query.m == null" v-model="mobile" @input="toNormalInput('j-mobile')" :class="{ 'j-mobile': true, 'error-input': errorInputClass === 'j-mobile' }" type="text" placeholder="请输入手机号码" maxlength="11"/>
      <p class="mobile-readonly" v-else>手机号：{{ mobile }}</p>
      <div class="ic">
        <input v-model="ic.value" @input="toNormalInput('j-ic')" :class="{ 'j-ic': true, 'error-input': errorInputClass === 'j-ic' }" type="text" placeholder="图片验证码" maxlength="4"/>
        <img @click="getIc" :src="ic.b64" />
      </div>
      <div class="mc">
        <input v-model="mc.value" @input="toNormalInput('j-mc')" :class="{ 'j-mc': true, 'error-input': errorInputClass === 'j-mc' }" type="text" placeholder="短信验证码" maxlength="6"/>
        <button @click="sendMc" :class="{ disabled: mc.status === 1 || mc.status === 3 }">{{ textBtnSendMc }}</button>
      </div>
      <div class="error">{{ error }}</div>
    </div>
    <div class="buttons">
      <button @click="findPwd" :class="{ disabled: isWorking }">设置密码</button>
    </div>
  </div>
</template>

<script>
import { getIc } from '@/api/common'
import { findPwdByMobile, sendFindPwdMc } from '@/api/userPassword'
import Constants from '@/assets/constants/Constants'
import CheckSign from '@/components/CheckSign'

export default {
  name: 'FindByMobile',
  extends: CheckSign,
  layout: 'LoginLayout',
  data () {
    return {
      error: '',
      mobile: this.$route.query.m == null ? '' : this.$route.query.m,
      isWorking: false,
      // 图片验证码
      ic: {
        id: null,
        b64: null,
        value: ''
      },
      // 手机验证码
      mc: {
        id: null, // 手机验证码id
        status: 0, // 0未发送，1正在发送，2发送完成，3阻塞中
        interval: 60, // 发送间隔
        value: '' // 验证码值
      },
      // 发送验证码按钮文案
      textBtnSendMc: '发送验证码',
      errorInputClass: null
    }
  },
  methods: {
    // 转成正常输入框
    toNormalInput (inputClassName) {
      if (inputClassName === this.errorInputClass) {
        this.errorInputClass = null
        this.error = ''
      }
    },
    // 获取图片验证码
    getIc () {
      getIc()
        .then(data => {
          this.ic.id = data.id
          this.ic.b64 = data.b64
        })
        .catch(() => {
          this.error = '获取图片验证码失败，请尝试点击验证码图片重新获取'
        })
    },
    // 发送短信验证码
    sendMc () {
      // 校验
      if (this.mc.status === 1 || this.mc.status === 3) return
      if (this.mobile.trim().length === 0) {
        document.getElementsByClassName('j-mobile')[0].focus()
        this.errorInputClass = 'j-mobile'
        this.error = '请输入手机号码'
        return
      }
      if (!/^1[3456789]\d{9}$/.test(this.mobile)) {
        document.getElementsByClassName('j-mobile')[0].focus()
        this.errorInputClass = 'j-mobile'
        this.error = '请输入正确的手机号码'
        return
      }
      if (this.ic.value.trim().length === 0) {
        document.getElementsByClassName('j-ic')[0].focus()
        this.errorInputClass = 'j-ic'
        this.error = '请输入图片验证码'
        return
      }
      // 请求发送
      this.error = ''
      this.mc.status = 1 // 发送中
      sendFindPwdMc(this.mobile, this.ic.id, this.ic.value)
        .then(mcid => {
          this.mc.id = mcid
          this.mc.status = 3 // 发送阻塞
          this.getIc()
        })
        .catch(({ code, message }) => {
          // 系统异常
          if (code === Constants.Status.ERROR.code) {
            this.error = '获取短信验证码失败，请尝试重新发送'
          } else if (code === 'IC_INCORRECT') {
            // 图片验证码错误
            document.getElementsByClassName('j-ic')[0].focus()
            this.errorInputClass = 'j-ic'
            this.error = message
          } else {
            // 其它
            this.error = message
          }
          this.mc.status = 2 // 发送失败
          this.getIc()
        })
    },
    // 找回密码
    findPwd () {
      if (this.isWorking) return
      // 校验
      if (this.mobile == null || this.mobile.trim().length === 0) {
        document.getElementsByClassName('j-mobile')[0].focus()
        this.errorInputClass = 'j-mobile'
        this.error = '请输入手机号码'
        return
      }
      if (!/^1[3456789]\d{9}$/.test(this.mobile)) {
        document.getElementsByClassName('j-mobile')[0].focus()
        this.errorInputClass = 'j-mobile'
        this.error = '请输入正确的手机号码'
        return
      }
      if (this.mc.value == null || this.mc.value.trim().length === 0) {
        document.getElementsByClassName('j-mc')[0].focus()
        this.errorInputClass = 'j-mc'
        this.error = '请输入短信验证码'
        return
      }

      // 发送注册请求
      this.error = ''
      this.isWorking = true
      findPwdByMobile(
        this.sign,
        this.mobile,
        this.mc.id,
        this.mc.value.trim()
      )
        .then(data => {
          this.isWorking = false
          this.$router.push({
            path: '/pwd/reset',
            query: {
              secure: data.secure,
              timestamp: data.timestamp,
              digest: data.digest,
              payload: this.$route.query.payload
            }
          })
        })
        .catch(({ code, message }) => {
          if (code === 'MC_INCORRECT') {
            document.getElementsByClassName('j-mc')[0].focus()
            this.errorInputClass = 'j-mc'
          }
          this.isWorking = false
          this.error = message
        })
    }
  },
  watch: {
    'mc.status': function (status) {
      if (status === 1) this.textBtnSendMc = '发送中...'
      else if (status === 2) this.textBtnSendMc = '重新发送'
      else if (status === 3) {
        let second = this.mc.interval
        const interval = setInterval(() => {
          this.textBtnSendMc = `已发送(${second}s)`
          second--
          if (second <= 0) {
            clearInterval(interval)
            this.mc.status = 2
          }
        }, 1000)
      }
    }
  },
  mounted () {
    // 获取验证码
    this.getIc()
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/style/variables";
.login {
  height: 398px;
  .inputs {
    // 只读手机号
    .mobile-readonly {
      height: 48px;
      line-height: 48px;
      color: #A0A0A0;
      font-size: 16px;
      background: #34353C;
      padding: 0 24px;
    }
    .ic,
    .mc {
      margin-top: 20px;
      overflow: hidden;
      input {
        width: 190px;
      }
      img, button {
        width: 140px;
        float: right;
        height: 48px;
        border: 0;
      }
      button {
        background: $primary-color;
        color: #fff;
        font-size: 16px;
        border: 0;
      }
    }
  }
}
</style>
